import React from 'react';

import { ProductDetailBackArrowContainer } from 'features/menu/components/product-detail/product-detail-flow/product-detail-back-arrow/styled';
import { IProductDetailBackArrow } from 'features/menu/components/product-detail/product-detail-flow/product-detail-back-arrow/types';

import { BackArrow } from 'components/navigation/back-arrow';
import { ClickEventComponentNames, logButtonClick } from 'state/amplitude';

export const ProductDetailBackArrow: React.FC<IProductDetailBackArrow> = ({
  onPress,
  eventAttributes = {},
}) => {
  const handlePress = () => {
    // Leaving goBack fow now, there will be new logic to handle this action based on each flow.
    onPress();

    logButtonClick({
      attributes: {
        ...eventAttributes,
        name: eventAttributes?.name ?? '',
        component: ClickEventComponentNames.PRODUCT_DETAIL_BACK_NAVIGATION,
      },
    });
  };

  return (
    <ProductDetailBackArrowContainer>
      <BackArrow onPress={handlePress} />
    </ProductDetailBackArrowContainer>
  );
};
